import React, { memo } from 'react';
import { Text } from '@raptormaps/text';
import { Switch } from '@raptormaps/switch';
import { Feature } from '../../api/services/features/features.schema';
import {
  PermissionFeatureCard,
  PermissionFeatureInfo,
  PermissionFeatureDescription,
} from './OrgDetails.styles';

export interface FeatureCardProps {
  feature: Feature;
  isEnabled: boolean;
  isDisabled: boolean;
  onToggle: (enabled: boolean) => void;
}

export const FeatureCard = memo(function FeatureCard({
  feature,
  isEnabled,
  isDisabled,
  onToggle,
}: FeatureCardProps) {
  return (
    <PermissionFeatureCard>
      <PermissionFeatureInfo>
        <Text variant="paragraph_medium_bold">{feature.name}</Text>
        {feature.description && (
          <PermissionFeatureDescription>
            {feature.description}
          </PermissionFeatureDescription>
        )}
      </PermissionFeatureInfo>
      <Switch
        checked={isEnabled}
        disabled={isDisabled}
        onCheckedChange={onToggle}
      />
    </PermissionFeatureCard>
  );
});
